import { Navigate, Outlet } from "react-router-dom";

import { useContext } from "react";
import { AuthContext } from "contexts/AuthContext";

// project imports
// import Customization from "../Customization";

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => {
  const { isAuthenticated } = useContext(AuthContext);

  if (isAuthenticated) return <Navigate to="/" replace />;

  return (
    <>
      <Outlet />
      {/* <Customization /> */}
    </>
  );
};

export default MinimalLayout;
